// src/pages/Carrito.js
import React from "react";
import Cart from "../components/Cart";

const Carrito = () => <Cart />;

export default Carrito;
